import "./App.css";
import Footer from "./components/Footer";
import CardsContainer from "./components/CardsContainer";
import Header from "./components/Header";

function App() {
  return (
    <div className="App">
      <Header />
      <CardsContainer />
      <Footer />
    </div>
  );
}

export default App;
